import React from "react";
import { useRouteError } from "react-router-dom";

const GlobalErrorElement: React.FC = () => {
  const error = useRouteError();
  console.error("Caught by GlobalErrorElement:", error);

  const isRouteResponse =
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    "statusText" in error;

  const message = error instanceof Error
    ? error.message
    : isRouteResponse
      ? `${String((error as { status?: unknown }).status)} ${String((error as { statusText?: unknown }).statusText)}`
      : "An unknown route error occurred.";

  return (
    <div
      style={{
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        padding: "16px",
        margin: "12px",
        borderRadius: "12px",
        border: "1px solid #e5e7eb",
        background: "#fff",
      }}
    >
      <h2 style={{ margin: "0 0 8px", fontSize: "18px" }}>Unable to load this page</h2>
      <p style={{ margin: 0, fontSize: "14px", color: "#374151" }}>{message}</p>
    </div>
  );
};

export default GlobalErrorElement;
